import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HeaderModule } from '@components/header/header.module';
import { LoadingModule } from '@components/loading/loading.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '@environments/environment';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { RecaptchaInterceptor } from '@common/interceptors/recaptcha.interceptor';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { BaseFormLayoutModule } from '@components/base-form-layout/base-form-layout.module';
import { LoadingService } from '@services/loading/loading.service';
import { ChileanCurrencyPipeModule } from '@pipes/chilean-currency/chilean-currency.module';
import { BaseLayoutModule } from '@components/base-layout/base-layout.module';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    TransferHttpCacheModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HeaderModule,
    LoadingModule,
    HttpClientModule,
    BreadcrumbModule,
    RecaptchaV3Module,
    BaseFormLayoutModule,
    ChileanCurrencyPipeModule,
    BaseLayoutModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    LoadingService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.RECAPTCHA_SITE_KEY
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RecaptchaInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
